import type { Dayjs } from 'dayjs'
import type { DailyCloseProductSearch } from '@/services/inventory/dailyCloseProduct/types'
import { DATE_PARAM_FORMAT, MAX_SEARCH_DAYS, MESSAGES } from './constants'

export interface DailyCloseProductFormValues {
  shipperCode?: string
  closeDateRange?: readonly [Dayjs | null, Dayjs | null] | null
  brandName?: string
  goodsCode?: string
  barcodes?: string[]
  logisticsServiceType?: string
}

export const validateDailyCloseProductForm = (values: DailyCloseProductFormValues): string | null => {
  const [from, to] = values.closeDateRange ?? []
  if (!from || !to) return MESSAGES.closeDateRequired
  if (from.isAfter(to, 'day')) return MESSAGES.closeDateInvalidRange
  if (to.diff(from, 'day') + 1 > MAX_SEARCH_DAYS) return MESSAGES.closeDatePeriodExceeded
  if (!values.shipperCode?.trim() && !values.logisticsServiceType?.trim()) return MESSAGES.shipperOrServiceTypeRequired
  // 1.0 RP02 는 상품코드·바코드가 둘 다 비면 조회하지 않는다. 화주 전체 한 달 상품별 집계는 BE 상한에 걸려 실패한다.
  const hasBarcode = (values.barcodes ?? []).some((barcode) => barcode.trim())
  if (!values.goodsCode?.trim() && !hasBarcode) return MESSAGES.goodsCodeOrBarcodeRequired
  return null
}

const trimmed = (value?: string): string | undefined => value?.trim() || undefined

export const toHeadSearch = (values: DailyCloseProductFormValues): DailyCloseProductSearch => {
  const [from, to] = values.closeDateRange ?? []
  if (!from || !to) throw new Error(MESSAGES.closeDateRequired)
  const barcodes = [...new Set((values.barcodes ?? []).map((barcode) => barcode.trim()).filter(Boolean))]
  const shipperCode = trimmed(values.shipperCode)
  const brandName = trimmed(values.brandName)
  const goodsCode = trimmed(values.goodsCode)
  const logisticsServiceType = trimmed(values.logisticsServiceType)

  return {
    ...(shipperCode ? { shipperCode } : {}),
    closeDateFrom: from.format(DATE_PARAM_FORMAT),
    closeDateTo: to.format(DATE_PARAM_FORMAT),
    ...(brandName ? { brandName } : {}),
    ...(goodsCode ? { goodsCode } : {}),
    ...(barcodes.length ? { barcodes } : {}),
    ...(logisticsServiceType ? { logisticsServiceType } : {}),
  }
}
